export const skills = {
  languages: [
    { name: "Java", icon: "FaJava" },
    { name: "TypeScript", icon: "SiTypescript" },
    { name: "JavaScript", icon: "FaJs" },
  ],
  frameworks: [
    { name: "Spring Boot", icon: "SiSpring" },
    { name: "Angular", icon: "SiAngular" },
    { name: "Next JS", icon: "SiNextdotjs" },
    { name: "Node.js", icon: "FaNodeJs" },
  ],
  libraries: [
    { name: "React", icon: "FaReact" },
    { name: "RxJs", icon: "SiReactivex" },
    { name: "Redux/NgRx", icon: "SiRedux" },
    { name: "Prime NG/React", icon: "SiPrime" },
    { name: "Ant Design", icon: "SiAntdesign" },
  ],
  tools: [
    { name: "Git", icon: "FaGitAlt" },
    { name: "GitHub", icon: "FaGithub" },
    { name: "GitLab", icon: "FaGitlab" },
    { name: "Jira", icon: "FaJira" },
  ],
  platforms: [
    { name: "VS Code", icon: "SiVisualstudiocode" },
    { name: "IntelliJ Idea", icon: "SiIntellijidea" },
    { name: "PostgreSQL", icon: "SiPostgresql" },
    { name: "Oracle", icon: "SiOracle" },
  ],
  softSkills: [
    { name: "Agile Workflow", icon: "FaProjectDiagram" },
    { name: "Technical Analysis", icon: "FaChartLine" },
    { name: "Communication", icon: "FaComments" },
    { name: "Software Best Practices", icon: "FaCode" },
  ],
};
